export const availableAdTypes: CampaignAdType[] = [
  'product',
  'banner',
  'sponsored_brand'
]
